<ejs-dropdownlist
  id='rtuListBox'
  #rtuListbox
  [dataSource]="rtuList"
  [fields]="fields"
  [allowFiltering]="true"
  (filtering)="onFiltering($event)"
  (beforeOpen)="onBeforeOpen($event)"
  cssClass="e-outline"
  [placeholder]="searchPlaceHolderText | translate"
  (select)="onSelect($event)"
>
</ejs-dropdownlist>
